/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */

import { useContext } from "react";
import { GlobalContext } from "../../providers/GlobalProvider";
import { IoHome } from "react-icons/io5";
import { FaBookOpen } from "react-icons/fa";
import { GrSchedule } from "react-icons/gr";
import { useLocation } from "react-router-dom";

export function NavBar({ children }) {
  const { student } = useContext(GlobalContext);
  const { pathname } = useLocation();
  const isCoursesRoute = pathname.startsWith("/courses/") || pathname === "/subscription";

  return (
    <div id="wrapper" className="app-layout">
      <ul
        className="navbar-nav sidebar sidebar-dark accordion app-sidebar"
        id="accordionSidebar"
      >
        <a
          className="sidebar-brand d-flex align-items-center justify-content-center app-brand"
          href="/home"
        >
          <div className="bg-white w-100 rounded p-3">
            <img src="/img/omega.7041f9d3.png" alt="Cursinho Ômega" />
          </div>
        </a>

        <hr className="sidebar-divider mt-3" />

        <li className={`nav-item ${pathname === "/home" ? "active" : ""}`}>
          <a className="nav-link" href="/home" aria-current={pathname === "/home" ? "page" : undefined}>
            <IoHome size={20} className="me-2 mb-2" />
            <span style={{ fontSize: 20, marginLeft: 10 }}>Inicio</span>
          </a>
        </li>

        <li className={`nav-item ${pathname === "/matricula" ? "active" : ""}`}>
          <a className="nav-link" href="/matricula" aria-current={pathname === "/matricula" ? "page" : undefined}>
            <FaBookOpen size={20} className="me-2 mb-2" />
            <span style={{ fontSize: 20, marginLeft: 10 }}>Meus Cursos</span>
          </a>
        </li>

        <li className={`nav-item ${pathname === "/agenda" ? "active" : ""}`}>
          <a className="nav-link" href="/agenda" aria-current={pathname === "/agenda" ? "page" : undefined}>
            <GrSchedule size={20} className="me-2 mb-2" />
            <span style={{ fontSize: 20, marginLeft: 10 }}>Agenda</span>
          </a>
        </li>

        <li className={`nav-item ${isCoursesRoute ? "active" : ""}`}>
          <a className="nav-link" href="/home" aria-current={isCoursesRoute ? "page" : undefined}>
            <FaBookOpen size={20} className="me-2 mb-2" />
            <span style={{ fontSize: 20, marginLeft: 10 }}>Nossos Cursos</span>
          </a>
        </li>

        <hr className="sidebar-divider d-none d-md-block" />

        <div className="sidebar-card d-none d-lg-flex app-sidebar-card">
          <p className="text-white small mb-3">Portal do aluno</p>
          <a
            className="w-100 btn btn-dark btn-sm"
            onClick={() => {
              localStorage.removeItem("token");
              setTimeout(() => {
                window.location.href = "/";
              }, 100);
            }}
          >
            Sair
          </a>
        </div>
      </ul>

      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <nav className="navbar navbar-expand navbar-light bg-white topbar static-top app-topbar">
            <button
              id="sidebarToggleTop"
              className="btn btn-link d-md-none rounded-circle mr-3"
            >
              <i className="fa fa-bars"></i>
            </button>

            <ul className="navbar-nav ml-auto">
              <div className="topbar-divider d-none d-sm-block"></div>

              <li className="nav-item dropdown no-arrow">
                <a
                  className="nav-link dropdown-toggle"
                  href="/home"
                  id="userDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                    {student?.name}
                  </span>
                  <img
                    className="img-profile rounded-circle"
                    src="img/undraw_profile.svg"
                    alt=""
                  />
                </a>
                <div
                  className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                  aria-labelledby="userDropdown"
                >
                  {/* <a className="dropdown-item" href="#">
                    <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                    Perfil
                  </a> */}
                  <div className="dropdown-divider"></div>
                  <a
                    className="dropdown-item"
                    onClick={() => {
                      localStorage.removeItem("token");
                      setTimeout(() => {
                        window.location.href = "/";
                      }, 100);
                    }}
                  >
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                    Sair
                  </a>
                </div>
              </li>
            </ul>
          </nav>
          <main className="app-content">{children}</main>
        </div>

        <footer className="sticky-footer bg-white app-footer">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>
                Copyright &copy; Matheus M Militão {new Date().getFullYear()}
              </span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
